























































import { Component, Vue } from 'vue-property-decorator'
import * as Reveal from '@/assets/scripts/RevealOnScrollModule'
import * as Animate from '@/assets/scripts/AnimateOnScrollModule'

@Component
export default class Home extends Vue {
	data() {
		return {
			PageTitle: "Animate on scroll"
		}
	}
	mounted() {
		new Reveal.revealOnScrollModule();
		new Animate.animateOnScrollModule();
	}
}
